
<kendo-formfield>
    <kendo-label *ngIf="!!caption" [text]="caption | translate"></kendo-label>
    <kendo-dropdownlist 
    [ngClass]="{'fx-fill': settings.fxFill, 'uppercase': settings.uppercase}" 
    [formControl]="control" 
    valuePrimitive="true" 
    [data]="valueList$ | async"
    [textField]="textField" 
    [valueField]="valueField" 
    (valueChange)="onChange($event)"
    [readonly]="settings.readonly">
    </kendo-dropdownlist>
</kendo-formfield>


  

